export default __webpack_public_path__ + "static/media/technical_certificate.1a6ad143.svg";